import categories from './categories'
import listingCategories from './listing-categories'
import categoryLocations from './category-locations'
import optionals from './optionals'
import locations from './locations'

const catalog = {
    categories: Object.assign(categories, categories),
    listingCategories: Object.assign(listingCategories, listingCategories),
    categoryLocations: Object.assign(categoryLocations, categoryLocations),
    optionals: Object.assign(optionals, optionals),
    locations: Object.assign(locations, locations),
}

export default catalog